import React, { useState, useEffect } from 'react';
import logo from '../../../assets/images/logo.png';
import { Button, Nav, Navbar } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import css from './Header.module.css';
import { usePWAInstall } from 'react-use-pwa-install';
import { Input } from 'antd';
import axios from 'axios';
import { useLoaderStore } from '../../SavingLoader/SavingStore';
import arrowimg from './../../../assets/Arrow.png';
import programma from "./../../../assets/app.apk"



function SiteHeader() {
    const [show, setShow] = useState(false);
    const install = usePWAInstall()
    let [sbooks, setSbooks] = useState([]);
    let [svideos, setSvideos] = useState([]);
    let [sarticles, setSarticles] = useState([]);

    const { pcarrow } = useLoaderStore();

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') setShow(false); };
        if (show) document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [show]);

    let handleSearch = (e) => {
        if (e.target.value.length > 0) {
            axios.post('/search', { q: e.target.value }).then(res => {
                setSbooks(res.data?.books);
                setSvideos(res.data?.videos);
                setSarticles(res.data?.posts);
            })
        } else {
            setSbooks([]);
            setSvideos([]);
            setSarticles([]);
        }
    }


    return (
        <>
            {/* Mobile fixed header */}
            <div className={css.mobileheader}>
                <NavLink to={'/'}><img src={logo} alt='Kitobxon' height={"28px"} /></NavLink>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <NavLink className={'nav-link'} to={'/mobile'} variant="primary" size="sm">
                        <Button variant="primary" size="sm">
                            <i className="bi bi-google-play"></i>
                        </Button>
                    </NavLink>
                    {install && <Button onClick={install} size="sm" variant="success">Yuklab olish</Button>}
                    <Link to={'/mybooks'} style={{ position: 'relative' }}>
                        <Button className='clean-btn' title='Saqlangan kitoblar' variant="outline-primary" size="sm">
                            <i className="bi bi-bookmark-fill"></i>
                        </Button>
                        {pcarrow && <img className={css.arrowImage} src={arrowimg} alt="Arrowimg" />}
                    </Link>
                    <Button onClick={() => setShow(true)} size="sm" variant="outline-secondary">
                        <i className="bi bi-search"></i>
                    </Button>
                </div>
            </div>
            <div className={css.mobileSpacer} />

            {/* Desktop fixed header */}
            <header className={css.headerWrapper}>
                <div className={css.headerInner}>
                    <Navbar expand="lg" className={css.siteheader}>
                        <Navbar.Brand href="/">
                            <img src={logo} alt='Kitobxon' height={"30px"} />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="navbarScroll">
                            <Nav className="me-auto my-1 my-lg-0" navbarScroll>
                                <NavLink className={'nav-link'} to="/">Bosh sahifa</NavLink>
                                <NavLink className={'nav-link'} to="/books">Kitoblar</NavLink>
                                <NavLink className={'nav-link'} to="/posts">Maqolalar</NavLink>
                                <NavLink className={'nav-link'} to="/music">Audio</NavLink>
                                <NavLink className={'nav-link'} to="/videos">Video</NavLink>
                                <NavLink className={'nav-link'} to={'/forum'}>Forum</NavLink>
                                <NavLink className={'nav-link'} to="/hujjatlar">Normativ-huquqiy hujjatlar</NavLink>
                                <NavLink className={'nav-link'} to="/tgposts">Testlar</NavLink>
                                <NavLink className={'nav-link'} to="/about">Biz haqimizda</NavLink>
                            </Nav>
                            <div className='d-flex gap-2 align-items-center'>
                                <NavLink className={'nav-link'} to={'/mobile'} target="_blank" variant="primary" size="sm">
                                    <i className="bi bi-google-play"></i> MOBIL ILOVA
                                </NavLink>
                                <Button onClick={() => setShow(true)} variant="outline-secondary" size="sm">
                                    <i className="bi bi-search"></i>
                                </Button>
                                <Link to={'/mybooks'} style={{ position: 'relative' }}>
                                    <Button className='clean-btn' title='Saqlangan kitoblar' variant="outline-primary" size="sm">
                                        <i className="bi bi-bookmark-fill"></i>
                                    </Button>
                                    {pcarrow && <img className={css.arrowImage} src={arrowimg} alt="Arrowimg" />}
                                </Link>
                                {install && (
                                    <Button onClick={install} variant="success" size="sm">
                                        <i className="bi bi-download"></i> Yuklab olish
                                    </Button>
                                )}
                            </div>
                        </Navbar.Collapse>
                    </Navbar>
                </div>
            </header>
            <div className={css.headerSpacer} />

            {/* Search modal */}
            {show && (
                <div className={css.searchOverlay} onClick={(e) => e.target === e.currentTarget && setShow(false)}>
                    <div className={css.searchBox}>
                        <div className={css.searchHeader}>
                            <Input
                                autoFocus
                                onInput={handleSearch}
                                size='large'
                                placeholder='Kitob, video yoki maqola qidiring...'
                                prefix={<i className="bi bi-search" style={{ fontSize: 18, color: '#94a3b8' }} />}
                                suffix={
                                    <button className={css.closeBtn} onClick={() => setShow(false)}>
                                        <i className="bi bi-x-lg"></i>
                                    </button>
                                }
                                className={css.searchInput}
                            />
                        </div>

                        {(sbooks?.length > 0 || svideos?.length > 0 || sarticles?.length > 0) ? (
                            <div className={css.searchResults}>
                                {sbooks?.length > 0 && (
                                    <div className={css.resultGroup}>
                                        <div className={css.groupLabel}><i className="bi bi-book"></i> Kitoblar</div>
                                        {sbooks.map((book, i) => (
                                            <Link key={i} to={`/book/${book.id}`} className={css.resultItem} onClick={() => setShow(false)}>
                                                <i className="bi bi-book-half"></i>
                                                <span>{book.name}</span>
                                                <i className="bi bi-arrow-right ms-auto"></i>
                                            </Link>
                                        ))}
                                    </div>
                                )}
                                {svideos?.length > 0 && (
                                    <div className={css.resultGroup}>
                                        <div className={css.groupLabel}><i className="bi bi-play-btn"></i> Videolar</div>
                                        {svideos.map((video, i) => (
                                            <Link key={i} to={`/video/${video.id}`} className={css.resultItem} onClick={() => setShow(false)}>
                                                <i className="bi bi-play-circle"></i>
                                                <span>{video.name}</span>
                                                <i className="bi bi-arrow-right ms-auto"></i>
                                            </Link>
                                        ))}
                                    </div>
                                )}
                                {sarticles?.length > 0 && (
                                    <div className={css.resultGroup}>
                                        <div className={css.groupLabel}><i className="bi bi-newspaper"></i> Maqolalar</div>
                                        {sarticles.map((article, i) => (
                                            <Link key={i} to={`/post/${article.id}`} className={css.resultItem} onClick={() => setShow(false)}>
                                                <i className="bi bi-file-text"></i>
                                                <span>{article.title}</span>
                                                <i className="bi bi-arrow-right ms-auto"></i>
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className={css.searchEmpty}>
                                <i className="bi bi-search" style={{ fontSize: 40, color: '#cbd5e1' }}></i>
                                <p>Qidiruv uchun matn kiriting</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Mobile bottom navigation */}
            <nav className={css.bottomnav}>
                <NavLink to={'/books'}><i className="bi bi-book"></i> Kitoblar</NavLink>
                <NavLink to="/posts"><i className="bi bi-newspaper"></i> Maqolalar</NavLink>
                <NavLink to="/music"><i className="bi bi-file-music"></i> Audio</NavLink>
                <NavLink to={'/videos'}><i className="bi bi-play-btn"></i> Videolar</NavLink>
                <NavLink to={'/tgposts'}><i className="bi bi-patch-question"></i> Testlar</NavLink>
            </nav>
        </>
    );
}

export default SiteHeader;